import { HttpClient, HttpClientModule } from "@angular/common/http";
import { ErrorHandler, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { Camera } from "@ionic-native/camera";
import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";
import { Geolocation } from "@ionic-native/geolocation";
// import { Facebook } from "@ionic-native/facebook";
import { Keyboard } from "@ionic-native/keyboard";
// import { IonicStorageModule, Storage } from "@ionic/storage";
import { Network } from "@ionic-native/network";

import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";
import { AngularFireModule } from "angularfire2";
import { AngularFireDatabaseModule } from "angularfire2/database";
import { FIREBASE_CONFIG } from "../config/firebase.credentials";
import { MyApp } from "./app.component";
import {
  AuthService,
  Wall,
  User,
  FirebaseActions,
  ShareData,
  Connectivity,
  CameraActions,
  DataStorage
} from "../providers/providers";


// The translate loader needs to know where to load i18n files
// in Ionic's static asset pipeline.
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [MyApp],
  imports: [
    BrowserModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    IonicModule.forRoot(MyApp, { animate: false }),
    // IonicModule.forRoot(
    //   MyApp,
    //   {
    //     platforms: { ios: { scrollAssist: false, autoFocusAssist: false } }
    //   },
    //   { animate: false }
    // ),
    AngularFireModule.initializeApp(FIREBASE_CONFIG),
    AngularFireDatabaseModule,
    // IonicStorageModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp],
  providers: [
    Camera,
    Geolocation,
    SplashScreen,
    StatusBar,
    // Facebook,
    Keyboard,
    Network,
    // Keep this to enable Ionic's runtime error handling during development
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    AuthService,
    Wall,
    User,
    FirebaseActions,
    CameraActions,
    ShareData,
    Connectivity,
    DataStorage
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts